"use client";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


/*-------------------------------------------------------
 *      CARD ANIMATION ENTRACE ONE BY ONE UPWARDS
 *------------------------------------------------------- */

interface RevealOptions{
    trigger?: string | Element;
    start?: string;
    y?: number;
    duration?: number;
    delayBetween?: number; 
}

export const revealOnScroll = (selector: string, options?: RevealOptions) => {

    const { trigger = selector, start = "top 85%", y = 60, duration = 0.8, delayBetween= 0.5,} = options || {};

    const elements = gsap.utils.toArray<HTMLElement>(selector);

    elements.forEach((el, index) => {
        gsap.fromTo(
            el,
            { opacity: 0, y },
            {
                opacity: 1,
                y: 0,
                duration,
                delay: index * delayBetween, // gap between each card
                ease: "power3.out",
                scrollTrigger: {
                    trigger: el,
                    start,
                    toggleActions: "play none none reverse",
                },
            }
        );
    });
};

/* ----------------------------------------------------------
 * LINE-BY-LINE TEXT REVEAL ANIMATION
 * ---------------------------------------------------------- */

interface LineRevealOptions {
  start?: string;
  duration?: number;
  lineDelay?: number;
  y?: number;
}

export const revealLinesOnScroll = (selector: string, options?: LineRevealOptions) => {

    const { start = "top 85%", duration = 0.7, lineDelay = 0.15, y = 30 } = options || {};

    const paragraphs = gsap.utils.toArray<HTMLElement>(selector);

    paragraphs.forEach((p) => {

        const text = p.innerHTML.trim();
        const lines = text.split("<br>").length > 1
        ? text.split("<br>")
        : text.split(/(?<=\.|\?|\!)\s+/); // crude line split (based on sentences)
        
        // Replace content with wrapped spans
        p.innerHTML = lines
        .map((line) => {
            const isBreak = line.trim() === ""; // handles empty line from <br/>
            return isBreak
            ? `<span class="line-break" style="display:block; height:1rem;"></span>`
            : `<span class="line-block" style="display:block; overflow:hidden; margin-bottom:0.5rem;">
                <span class="line-inner" style="display:inline-block; transform:translateY(${y}px); opacity:0;">
                    ${line}
                </span>
                </span>`;
        })
        .join("");


        const lineEls = p.querySelectorAll(".line-inner");

        gsap.to(lineEls, {
            opacity: 1,
            y: 0,
            duration,
            ease: "power3.out",
            stagger: lineDelay,
            scrollTrigger: {
                trigger: p,
                start,
                toggleActions: "play none none reverse",
            },
        });
    });
};

/*--------------------------------------------------
 *       REVEAL IMAGE CURTAIN
 *-------------------------------------------------*/
export const revealImageCurtain = ( selector: string, options?: { duration?: number; ease?: string; start?: string }) => {

    const { duration = 1.2, ease = "power2.out", start = "top 80%" } = options || {};
    const images = gsap.utils.toArray<HTMLElement>(selector);

    images.forEach((img) => {

        // Set initial clip-path (hidden from left to right)
        gsap.set(img, {
            clipPath: "inset(0 100% 0 0)",
        });

        // Animate to fully visible
        gsap.to(img, {
            clipPath: "inset(0 0% 0 0)",
            duration,
            ease,
            scrollTrigger: {
                trigger: img,
                start,
                toggleActions: "play none none reverse",
            },
        });
    });
};
